/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import 'ress'
import wrapWithProvider from './wrap-with-provider'
export const wrapRootElement = wrapWithProvider

export const onRouteUpdate = () => {
  try {
    const headerLinks = document.querySelector('header').querySelectorAll('a')
    const footerLinks = document.querySelector('footer').querySelectorAll('a')
    const links = Array.from(headerLinks).concat(Array.from(footerLinks))

    links.forEach(link => {
      link.addEventListener('click', function (event) {
        if (this.target !== '_blank') {
          const href = this.getAttribute('href')
          if (!href.includes('http')) {
            event.preventDefault()
            location.href = href
          }
        }
      })
    })
  } catch (err) {
    console.log(err)
  }
}
